import { IconProps } from "../../utils/global-types/global-types";

const ChevronIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <g clipPath="url(#clip0_300_29395)">
      <path
        fill="currentColor"
        d="m9.589 11.257 3.333-3.334a.833.833 0 0 0-1.178-1.178L9 9.49 6.256 6.745a.833.833 0 0 0-1.179 1.178l3.334 3.334a.833.833 0 0 0 1.178 0"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_300_29395">
        <path fill="currentColor" d="M14 4v10H4V4z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default ChevronIcon;
